// File for logic corresponding to header component
import './header.scss';

function toggleMenuBtnClass() {
  const menuBtn = document.querySelector('.nav-toggle');

  if (! menuBtn) {
    return;
  }

  menuBtn.addEventListener('click', () => {
    menuBtn.classList.toggle('open');
  });
}

window.addEventListener('DOMContentLoaded', () => {
  toggleMenuBtnClass();
});
